import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dynamic-anchor"
export default class extends Controller {
  // Use this controller if you have a link to an anchor but the content of the
  // page is dynamically loaded.
  // This will ensure the correct position of the scroll at the moment of the click
  connect() {
    if (!this.element.getAttribute("href").startsWith("#")) return;

    this.element.onclick = (event) => {
      event.preventDefault();

      const target = document.querySelector(this.element.getAttribute("href"));
      target.scrollIntoView();
    };
  }
}
